import "./ConfirmarTurnoModal.css";
import { useContext, useState } from "react";
import { IonSpinner } from "@ionic/react";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import { PortalContext } from "../../../context/Provider";
import { GlobalContext } from "../../../../global/context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { wsConfirmarTurno } from "../../../context/Actions/turnos/turnosPaciente";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import { amOrPm } from "../../../../global/utils/amOrPm";

/**
 * Modal "¿Estas seguro que deseas confirmar el turno?".
 *
 * Unico punto donde se hace el POST de confirmacion desde la app. Lo abren:
 *  - el boton "Confirmar" de la card (CardTurnoFooter),
 *  - el efecto confirmarIdTurno de ProximosTurnos, que a su vez viene del boton
 *    "Confirmá tu turno" del push y del tap sobre el banner de un push de
 *    confirmacion (en iOS los botones solo aparecen con long-press, asi que el
 *    tap simple tiene que llevar al mismo lugar).
 *
 * Mismo endpoint y usuario (MOBILE) que la confirmacion en background del push.
 * "Ya estaba confirmado" (recepcion, o lista desactualizada) se trata como exito.
 *
 * Props: turno (idturno, fecha, hora, especialidad, centro), idPacienteFamiliar,
 * onConfirmado (callback tras exito: recargar la lista).
 */
const ConfirmarTurnoModal = ({ turno, idPacienteFamiliar, onConfirmado }) => {
  const { modalDispatch } = useContext(PortalContext);
  const { toasterDispatch } = useContext(GlobalContext);
  const [confirmando, setConfirmando] = useState(false);

  const cerrar = () => hideModal()(modalDispatch);

  const confirmar = () => {
    if (confirmando) return;
    setConfirmando(true);
    wsConfirmarTurno(turno?.idturno, idPacienteFamiliar || null, (ok, data) => {
      setConfirmando(false);
      const mensaje = data?.userMessage || "";
      const yaConfirmado = !ok && /ya se encuentra confirmado/i.test(mensaje);
      const exito = ok || yaConfirmado;
      showToaster(
        {
          texto: ok
            ? "Turno confirmado. ¡Te esperamos!"
            : yaConfirmado
              ? "Tu turno ya estaba confirmado."
              : mensaje || "No pudimos confirmar el turno. Intentá de nuevo.",
          tipo: exito ? "success" : "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      if (exito) {
        cerrar();
        if (typeof onConfirmado === "function") onConfirmado();
      }
    })();
  };

  const detalle = turno
    ? `${turno.especialidad || "Turno"} del ${getDiaStrTurno(turno.fecha)} ${getDiaStrTurno(
        turno.fecha,
        true
      )} a las ${turno.hora} ${amOrPm(turno.hora)}${turno.centro ? ` en ${turno.centro}` : ""}.`
    : "";

  return (
    <>
      <HeaderModal titulo="Confirmar turno" dissmiss={cerrar} />
      <div className="ptur-modalBody-container">
        <div className="ptur-modalBody-mensaje ptur-ConfirmarTurnoModal-mensaje">
          <span className="rb16m c-latex10">
            ¿Estás seguro que deseas confirmar el turno?
          </span>
          {detalle && <span className="rb16t c-latex10">{detalle}</span>}
        </div>
        <div className="ptur-ConfirmarTurnoModal-botones">
          <button className="btn ptur-ConfirmarTurnoModal-no" onClick={cerrar} disabled={confirmando}>
            No
          </button>
          <button
            className="btn ptur-ConfirmarTurnoModal-si"
            onClick={confirmar}
            disabled={confirmando}
          >
            {confirmando ? <IonSpinner name="lines-small" /> : "Sí, confirmar"}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmarTurnoModal;
